import React, { useEffect, useState } from 'react'
import axios from 'ps-components/lib/apiClient';
import { ResultsTable } from './ResultsTable'
import Button from 'ps-components/Button/Button'
import Input from 'ps-components/Input/Input';
import CheckboxInput from 'ps-components/Input/CheckboxInput';
import './SurveyData.scss'
import { toast } from 'react-toastify';

interface ClickEvent {
    target: {
        value: string
    }
    currentTarget: {
        value: string
    }
}
export default function() {
    const initialStateStats = { lastBatchTime: null, processed: 0, pending: 0, problemSurveyCount: 0 };
    const [stats, setStats] = useState(initialStateStats);
    const initialStateResults: object[] = [];
    const [tableData, setTableData] = useState(initialStateResults);
    const [query, setQuery] = useState('');
    const [loading, setLoading] = useState(false);
    const [showProblemSurveys, setProblemSurveys] = useState(false);
    const [surveyCodesValue, setSurveyCodesValue] = useState('');

    const getStats = async () => {
        try {
            const { data } = await (axios as any).apiGet('/api/elasticsearch/admin/survey-audit/getProgress');
            if (data.success) setStats({ 
                lastBatchTime: data.lastBatchTime,  
                ...data.progress,
                problemSurveyCount: data.problemSurveyCount
            })
          return data;
        } catch (err) {
          console.error(err)
          return { success: false }
        }
    }

    const startAudit = async () => {
        try {
            const { data } = await axios.apiPost('/api/elasticsearch/admin/survey-audit/start');
            if (data.message) toast(data.message, {type: 'info' });
            if (data.success) setTableData([]);
        } catch(err) {
            toast('Could not start survey data audit', {type: 'error'});
        }
    }

    const resumeAudit = async () => {
        try {
            const { data } = await axios.apiPost('/api/elasticsearch/admin/survey-audit/resume');
            if (data.message) toast(data.message, {type: 'info' });
        } catch(err) {
            toast('Could not resume survey data audit', {type: 'error'});
        }
    }

    const getAuditResults = async (query?: string) => {
        setLoading(true);
        try{
            const { data } = await axios.apiGet('/api/elasticsearch/admin/survey-audit/findProcessedBySurveyCode', { params: { query, showProblemSurveys } })
            if (data.success) setTableData(data.items);
        } catch(err) {
            toast('Get audit results failed', {type: 'error'});
        }
        setLoading(false);
    }

    const findIndexStatus = async () => {
        setTableData([]);
        setLoading(true);
        try{
            console.log('codes value: ', surveyCodesValue);
            const surveyCodes = surveyCodesValue.replace(/,/g, ' ').replace(/\s/g, ' ').split(' ').filter(sc => sc)
            console.log('codes: ', surveyCodes);

            const { data } = await axios.apiPost('/api/elasticsearch/admin/survey-audit/findIndexStatus', { surveyCodes })
            if (data.success) setTableData(data.items);
        } catch(err) {
            toast('Find index status failed', {type: 'error'});
        }
        setLoading(false);
    }
     
      useEffect(()=> {
        getStats();
        getAuditResults(query);
      }, [showProblemSurveys]);

    return (
        <div>
            <h3 className='minimum-wage-title'>Survey Data Management</h3>
            <div className='control-section'>
                <p className='control-section-label'> Audit Stats</p>
                <p>
                    <span className='stat'>Processed: {stats.processed}</span> 
                    <span className='stat'>Pending: {stats.pending} </span>
                    <span className='stat'>Last survey batch processed at: {stats.lastBatchTime || 'N/A'}</span>
                </p>
                <p>Problem Survey Count: {stats.problemSurveyCount}</p>
                <Button onClick={getStats}>Refresh Audit Stats</Button>
            </div>

            <div className='control-section'>
                <p className='control-section-label'> Audit Controls</p>
                <Button onClick={startAudit}>Start Audit</Button>
                <Button onClick={resumeAudit}>Resume Audit</Button>
            </div>
            
            <div className='control-section'>
                <p className='control-section-label'>Search Audit Result Data</p>
                <CheckboxInput
                    checked={showProblemSurveys}
                    onClick={() => {
                        setProblemSurveys(!showProblemSurveys);

                    }}
                /> Show Only Problem Surveys 
                <br />
                <Input 
                    value={query}
                    onChange={(e: ClickEvent) => { setQuery(e.currentTarget.value) }}
                    placeholder='SURVEY-CODE'
                />
                <Button onClick={() => getAuditResults(query)}>Get Audit Results</Button>
            </div>

            <div className='control-section adhoc-index-status'>
                <p className='control-section-label'>Adhoc Index Status</p>
                <Input
                    value={surveyCodesValue}
                    onChange={(e: ClickEvent) => { setSurveyCodesValue(e.currentTarget.value) }}
                    placeholder='SURVEY-CODE SURVEY-CODE, SURVEY-CODE'
                />
                <Button onClick={findIndexStatus}>Get Index Status</Button>
                <p className='control-section-label'>* Copy and paste a list of surveys. Use spaces or commas as separators</p>
            </div>
            
            <ResultsTable rows={tableData} loading={loading} />
        </div>
    )
}